export default __webpack_public_path__ + "media/images/features/yado/sample_img_3-718452e30c5df7ac572b72dbab517d9c.jpg";